// Small offline knowledge base for when the network drops.
// Matched by keyword-contains (case-insensitive). Uses simple English answers
// but the Chat page will still speak them in the currently-selected TTS locale.
// School staff can extend this file directly.

export const OFFLINE_FAQ = [
  {
    keywords: ["period", "menstruation", "बलीड", "माहवारी", "पीरियड", "মাসিক", "மாதவிடாய்", "मासिक"],
    answer: "A period is when a small amount of blood comes out of the body once a month. It is completely normal and every girl gets it as she grows up. It usually lasts 3 to 7 days.",
  },
  {
    keywords: ["cramp", "pain", "दर्द", "वेदना", "ব্যথা", "வலி"],
    answer: "Period cramps are normal. Drink warm water, place a warm cloth on your tummy, walk slowly, and rest. If the pain is very strong, please talk to your school nurse or a doctor.",
  },
  {
    keywords: ["pad", "hygiene", "स्वच्छता", "पैड", "প্যাড", "நாப்கின்"],
    answer: "Change your pad every 4 to 6 hours. Wash your hands before and after. Wrap the used pad in paper and put it in a covered bin. Never flush pads in the toilet.",
  },
  {
    keywords: ["scared", "shy", "embarrass", "डर", "शर्म", "பயம்", "লজ্জা"],
    answer: "It is okay to feel shy or scared. Every girl and woman goes through this. You are not alone. Talk to your mother, sister, teacher, or a trusted adult — they will help you.",
  },
  {
    keywords: ["bad touch", "unsafe", "safety", "गलत छूना", "बुरा स्पर्श", "பாதுகாப்பு", "নিরাপত্তা"],
    answer: "Your body belongs to you. If anyone touches you in a way that feels uncomfortable, wrong, or scary, say NO loudly, move away, and tell a trusted adult right away. It is never your fault. You can also call Childline 1098.",
  },
  {
    keywords: ["career", "job", "future", "करियर", "नौकरी", "ভবিষ্যৎ", "வேலை"],
    answer: "You can be anything you dream of — a doctor, engineer, teacher, artist, scientist, pilot, or entrepreneur. Take the Career Quiz on this app to see what fits your personality.",
  },
  {
    keywords: ["puberty", "body change", "growing", "बदलाव", "শরীর"],
    answer: "During puberty your body grows and changes — that is why you get periods, body hair, and sometimes mood swings. It is a natural, healthy part of growing into a young woman.",
  },
  {
    keywords: ["mood", "sad", "cry", "उदास", "মন", "মন খারাপ"],
    answer: "Mood swings during and before your period are normal because of hormones. Rest well, breathe slowly, and talk to a friend or someone you trust. If sadness stays for many days, please speak to a school counsellor.",
  },
];

export function matchOffline(query) {
  if (!query) return null;
  const q = query.toLowerCase();
  for (const item of OFFLINE_FAQ) {
    for (const kw of item.keywords) {
      if (q.includes(kw.toLowerCase())) return item.answer;
    }
  }
  return null;
}
